import Bacon from 'baconjs';
import $ from 'jquery';
import { createArticleCardRendering } from 'scripts/renderings/article-rendering';

const createRadioButtonLabelRendering = (text, htmlClass) => {
  return `
      <label class="btn btn-default">
        <input type="radio" name="${htmlClass}" value="${text}"> ${text}
      </label>
    `;
};

const checkRadioButton = ($radioButtonLabel) => {
  $radioButtonLabel.addClass('active');
  const $radioButtonInput = $radioButtonLabel.find('input');
  $radioButtonInput.attr('checked', 'checked').trigger('change');
};

const renderRadioButtons = ($buttonGroup, values, radioButtonName) => {
  if (!values || values.length < 1) {
      $buttonGroup.parents('fieldset').hide();
  } else {
    $buttonGroup.parents('fieldset').show();
    const newRadioButtonLabelRenderings = values.map(val => createRadioButtonLabelRendering(val, radioButtonName));

    const $showAllRadioButtonLabel = $buttonGroup.find('label.show-all-button');
    const $oldRadioButtonLabels = $buttonGroup.find('label:not(.show-all-button)');

    checkRadioButton($showAllRadioButtonLabel);

    $oldRadioButtonLabels.remove();
      $buttonGroup.append(newRadioButtonLabelRenderings);
  }
};

let articlePages = undefined;
const defaultFilter = 'Alle';

const renderArticles = (segmentFilter, productCategory, texts) => {
  let filteredArticles = articlePages;
  if (segmentFilter !== defaultFilter) {
    filteredArticles = $.grep(filteredArticles, (article) => {
      return article.customerSegments.indexOf(segmentFilter) !== -1;
    });
  }
  if (productCategory !== defaultFilter) {
    filteredArticles = $.grep(filteredArticles, (article) => {
      return article.productCategoryValues.indexOf(productCategory) !== -1;
    });
  }
  let articlesHtml = filteredArticles.map(a => createArticleCardRendering(a, texts, false));
  if (filteredArticles.length === 0) {
    articlesHtml = '<p class="container-text">' + texts.beklager + '</p>';
  }
  $('#articles-container').html(articlesHtml);
  window.picturefill();
};

const registerEvents = (texts) => {
  let currentCustomerSegment = defaultFilter;
  let currentProductCategory = defaultFilter;

  const $customerSegment = $('input[name=customer-segment]');
  const customerSegmentEventStream = Bacon.fromEvent($customerSegment, 'change').map(event => event.target.value);
  customerSegmentEventStream.onValue((targetValue) => {
    renderArticles(targetValue, currentProductCategory, texts);
    currentCustomerSegment = targetValue;
  });

  const $productCategory = $('input[name=product-category]');
  const productCategoryEventStream = Bacon.fromEvent($productCategory, 'change').map(event => event.target.value);
  productCategoryEventStream.onValue((targetValue) => {
    renderArticles(currentCustomerSegment, targetValue, texts);
    currentProductCategory = targetValue;
  });
};

const checkForFilterCategories = (viewModel) => {
  // Added check for customerSegmentsUnique is defined, as Aktiv Articles does not contain it in it's ViewModel.
  const productCategoriesUniqueNone = viewModel.productCategoriesUnique.length < 1;
  let customerSegmentsUniqueNone = true;
  if (typeof viewModel.customerSegmentsUnique !== 'undefined') {
    customerSegmentsUniqueNone = viewModel.customerSegmentsUnique.length < 1;
  }

  if (customerSegmentsUniqueNone && productCategoriesUniqueNone) {
      $('#article-filters').hide();     
  }
};

const initPage = (articleViewModel, texts) => {
  renderRadioButtons($('#customer-segment-filter'), articleViewModel.customerSegmentsUnique, 'customer-segment');
  renderRadioButtons($('#product-category-filter'), articleViewModel.productCategoriesUnique, 'product-category');
  checkForFilterCategories(articleViewModel);
  registerEvents(texts);
  articlePages = articleViewModel.articleListPage.articlePages.filter(ap => ap.showInArticleList === true && ap.article !== null);
  renderArticles(defaultFilter, defaultFilter, texts);
};

export { initPage };
